
// Time to wait after a successful load before clearing out the state
export const LOADING_INDICATOR_CLEAR_TIMEOUT = 1000;

export const LOADING_INDICATOR_STATE_LOADING = 'LOADING';
export const LOADING_INDICATOR_STATE_ERROR = 'ERROR';
export const LOADING_INDICATOR_STATE_LOADED = 'LOADED';
